<template>

    <transition
        name="fade"
        mode="out-in"
        appear>

        <button :class="{ 'ready color-bg-primary': loaded, 'color-base-text': !loaded }" @click="handleClick">

            <transition
                name="fade"
                mode="out-in">
                <span class="label loaded" v-html="buttonLabel" v-if="loaded" key="loaded"></span>
                <span class="label loading" v-html="buttonLabel" v-else key="loading"></span>
            </transition>

            <span class="progress">
                <span class="indicator" :style="{ backgroundColor: cssPropColor('$color-primary') }"></span>
            </span>

        </button>

    </transition>

</template>


<script>

    let vm = {};

    export default {

        name: 'progress-button',

        props: [
            'loadingLabel',
            'readyLabel',
            'method'
        ],

        components: {},

        data() {
            return {

            }
        },

        computed: {

            loaded() {
                return this.$dataStore.getters.getLoadedState;
            },

            buttonLabel() {
                return (this.loaded) ? this.readyLabel : this.loadingLabel;
            }

        },

        created() {
            this.$eventBus.$on('loading:ready', this.setReady);
        },

        mounted() {
            vm = this;
        },

        methods: {

            handleClick() {
                if (vm.$md.phone()) {
                    this.method();
                }
            },

            setReady() {
                vm.$dataStore.dispatch('LOADED', { val: true });
            },

            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';
    @import '../assets/styles/helpers/mixins';

    button {
        background-color: $white-100;
        width: 300px;
        height: 30px;
        margin: 0 0 6px 0;
        padding: 0 0 0 0;
        border: 0 none;
        border-radius: 15px;
        outline: 0;
        position: relative;
        overflow: hidden;
        pointer-events: none;
        transition: all 0.8s $easeInOutQuad;

        &:hover {
            cursor: default;
        }

        &.ready {
            background-color: var(--color-primary);
            width: 170px;
            height: 36px;
            margin: 0 0 0 0;
            border-radius: 2px;
            pointer-events: auto;
            transition: all 0.8s $easeInOutQuad;

            &:hover {
                cursor: pointer;
            }
        }
    }

    .label {
        font-family: $font-univers-std;
        color: $white-100;
        display: block;
        position: relative;
        z-index: 5;
        transition: none;

        &.loading {
            font-size: 0.625rem;
            line-height: 1;
            color: $white-100;
            letter-spacing: 1px;
            text-transform: uppercase;
            animation-duration: 0.3s;
            animation-delay: 0s;
        }

        &.loaded {
            font-size: 1rem;
            color: $white-100;
            letter-spacing: initial;
            text-transform: none;
            animation-duration: 0.3s;
            animation-delay: 0.3s;
        }
    }

    .progress {
        width: 100%;
        height: 100%;
        opacity: 1;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        overflow: hidden;
        transition: all 1.3s $easeInOutQuad;

        .ready & {
            opacity: 0;
            transition: all 1.3s $easeInOutQuad;
        }

        & .indicator {
            background-color: var(--color-primary);

            &:before {
                content: '';
                position: absolute;
                background-color: inherit;
                top: 0;
                left:0;
                bottom: 0;
                will-change: left, right;
                animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
                transform: skew(-45deg);
            }
            &:after {
                content: '';
                position: absolute;
                background-color: inherit;
                top: 0;
                left:0;
                bottom: 0;
                will-change: left, right;
                animation: indeterminate-short 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
                animation-delay: 1.15s;
                transform: skew(-45deg);
            }
        }
    }

    @include keyframes(indeterminate) {
        0% {
            left: -35%;
            right:100%;
        }
        60% {
            left: -35%;
            right: -90%;
        }
        100% {
            left: 110%;
            right: -90%;
        }
    }

</style>


// WEBPACK FOOTER //
// ProgressButton.vue?5c1719a9